import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: null,
};

const getDepartmentPositionDetailSlice = createSlice({
  name: "getDepartmentPositionDetail",
  initialState,
  reducers: {
    getDepartmentPositionDetailStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getDepartmentPositionDetailSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getDepartmentPositionDetailFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  getDepartmentPositionDetailStart,
  getDepartmentPositionDetailSuccess,
  getDepartmentPositionDetailFailed,
} = getDepartmentPositionDetailSlice.actions;

export default getDepartmentPositionDetailSlice.reducer;
